import { render, staticRenderFns } from "./BRMatchCard.vue?vue&type=template&id=47b69b10&"
import script from "./BRMatchCard.vue?vue&type=script&lang=js&"
export * from "./BRMatchCard.vue?vue&type=script&lang=js&"
import style0 from "./BRMatchCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports